module.exports = __webpack_public_path__ + "static/img/logistics-h5-3.c3603ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/logistics-h5-3.png
// module id = kH9q
// module chunks = 34